import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { useParams } from 'react-router-dom';
import { EmailActivationPageLayout } from 'views/layouts/EmailActivationPageLayout';
import { Splash } from 'views/components/molecules/Splash';
import { DeviceDomain } from 'models/Device';
import { useIntl } from 'react-intl';
import { localeIds } from 'locals';
import { setExceptionError } from 'stores/errorSlice';
import { useAppDispatch } from 'stores/type';
import { ROUTER_PATH } from 'views/constants';

interface EmailActivationPageParams {
  activationCode: string;
}

export const EmailActivationPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const { activationCode } = useParams<EmailActivationPageParams>();
  const [message, setMessage] = useState<string | undefined>(undefined);

  useEffect(() => {
    const activate = async () => {
      DeviceDomain.emailActivation(activationCode)
        .then((result) => {
          if (result.isFailure()) {
            setMessage(
              intl.formatMessage({
                id: localeIds.emailActivationPage.error.tokenInvalid,
              })
            );
            return;
          }

          setMessage(
            intl.formatMessage({ id: localeIds.emailActivationPage.success })
          );
        })
        .catch((e) => {
          dispatch(setExceptionError(e));
        });
    };

    activate();
  }, [activationCode, dispatch, intl]);

  if (!activationCode) {
    return <Redirect to={ROUTER_PATH.home} />;
  } else if (message) {
    return (
      <DefaultTemplate
        headerText={intl.formatMessage({
          id: localeIds.emailActivationPage.title,
        })}
      >
        <EmailActivationPageLayout message={message} />
      </DefaultTemplate>
    );
  } else {
    return (
      <DefaultTemplate headerText="">
        <Splash />
      </DefaultTemplate>
    );
  }
};
